export default "__VITE_ASSET__CJOCC0PW__"